export enum ScheduleViewMode {
  DAY = 'DAY',
  WEEK = 'WEEK',
}
